import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaDt_1.mjs'
import FormChoose from './FormChooseDt_1.jsx'
import TableChoose from './TableChooseDt_1.jsx'
import api from './apiDt_1.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
    })
}
